/* eslint import/prefer-default-export: */
export { default as FilterContainer } from './containers/FilterContainer';
